import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Tab, Tabs } from '@blueprintjs/core';
import Hclust from './Hclust';
import Pca from './Pca';
import Mds from './Mds';
import Iframe from 'react-iframe'
import './Multivar.css';

class MultivarStats extends React.PureComponent {

  state = {
    selectedTabId:'xtab'
  }


  handleTabChange = (navbarTabId) => this.setState({ selectedTabId: navbarTabId });

  render() {
    const { t, urls } = this.props;

    const main = (urls.main) ? <Iframe className='iframe' url={urls.main.mainTable} /> : false ;
    const xtab = (urls.xtab) ? <Iframe className='iframe' url={urls.xtab.main} /> : false ;
    const hclust = (urls.hclust) ? <Hclust plotUrl={urls.hclust.plot} distMatUrl={urls.hclust.distMat} /> : false ;
    const pca = (urls.pca) ? <Pca varPlotUrl={urls.pca.varPlot} indPlotUrl={urls.pca.indPlot} /> : false ;
    const mds = (urls.mds) ? <Mds plotUrl={urls.mds.plot} distMatUrl={urls.mds.distMat} /> : false ;
    const ca = (urls.ca) ?<Iframe className='iframe' url={urls.ca.plot} /> : false;


    return (
        <Tabs onChange={this.handleTabChange} selectedTabId={this.state.selectedTabId}>
          { main && <Tab id='main' title={t('mainTable')} panel={main}/> }
          { xtab && <Tab id='xtab' title={t('xtab')} panel={xtab}/> }
          { hclust && <Tab id='hclust' title={t('hclust')} panel={hclust} /> }
          { pca  && <Tab id='pca' title={t('pca')} panel={pca} /> }
          { mds && <Tab id='mds' title={t('mds')} panel={mds} /> }
          { ca &&   <Tab id='ca' title={t('ca')} panel={ca} /> }
        </Tabs>
    );
  }
}

MultivarStats.propTypes = {
   urls: PropTypes.object
};

export default withTranslation()(MultivarStats);
